import { withKeys as _withKeys, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-62daeb8c"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["placeholder"]
const _hoisted_2 = ["placeholder"]
const _hoisted_3 = ["placeholder"]
const _hoisted_4 = ["placeholder"]
const _hoisted_5 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.pInputInfo.type === 'T')
      ? _withDirectives((_openBlock(), _createElementBlock("input", {
          key: 0,
          class: "commonInput",
          onKeyup: _cache[0] || (_cache[0] = _withKeys(
//@ts-ignore
(...args) => (_ctx.enterEvent && _ctx.enterEvent(...args)), ["enter"])),
          type: "text",
          placeholder: _ctx.pInputInfo.placeholder,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.mInputValue.value) = $event))
        }, null, 40, _hoisted_1)), [
          [_vModelText, _ctx.mInputValue.value]
        ])
      : _createCommentVNode("", true),
    (_ctx.pInputInfo.type === 'P')
      ? _withDirectives((_openBlock(), _createElementBlock("input", {
          key: 1,
          class: "commonInput",
          onKeyup: _cache[2] || (_cache[2] = _withKeys(
//@ts-ignore
(...args) => (_ctx.enterEvent && _ctx.enterEvent(...args)), ["enter"])),
          type: "password",
          placeholder: _ctx.pInputInfo.placeholder,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.mInputValue.value) = $event))
        }, null, 40, _hoisted_2)), [
          [_vModelText, _ctx.mInputValue.value]
        ])
      : _createCommentVNode("", true),
    (_ctx.pInputInfo.type === 'N')
      ? _withDirectives((_openBlock(), _createElementBlock("input", {
          key: 2,
          class: "commonNumber",
          type: "number",
          placeholder: _ctx.pInputInfo.placeholder,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.mInputValue.value) = $event))
        }, null, 8, _hoisted_3)), [
          [_vModelText, _ctx.mInputValue.value]
        ])
      : (_ctx.pInputInfo.type === 'TA')
        ? _withDirectives((_openBlock(), _createElementBlock("textarea", {
            key: 3,
            class: "commonTextarea",
            onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.clickEvent && _ctx.clickEvent(...args))),
            onKeyup: _cache[6] || (_cache[6] = _withKeys(
//@ts-ignore
(...args) => (_ctx.enterEvent && _ctx.enterEvent(...args)), ["enter"])),
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.mInputValue.value) = $event)),
            placeholder: _ctx.pInputInfo.placeholder,
            style: _normalizeStyle({ backgroundColor: _ctx.pInputInfo.backgrounColor, padding: _ctx.pInputInfo.padding})
          }, null, 44, _hoisted_4)), [
            [_vModelText, _ctx.mInputValue.value]
          ])
        : (_ctx.pInputInfo.type === 'S')
          ? _withDirectives((_openBlock(), _createElementBlock("select", {
              key: 4,
              class: "commonSelect ommonNormalText",
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.mInputValue.value) = $event))
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pInputInfo.options, (each, index) => {
                return (_openBlock(), _createElementBlock("option", {
                  value: each.value,
                  key: index
                }, _toDisplayString(each.opt), 9, _hoisted_5))
              }), 128))
            ], 512)), [
              [_vModelSelect, _ctx.mInputValue.value]
            ])
          : _createCommentVNode("", true)
  ], 64))
}